import { render } from "./ElementPositionPanel.vue?vue&type=template&id=15c9ddcc&scoped=true&ts=true"
import script from "./ElementPositionPanel.vue?vue&type=script&lang=ts"
export * from "./ElementPositionPanel.vue?vue&type=script&lang=ts"

import "./ElementPositionPanel.vue?vue&type=style&index=0&id=15c9ddcc&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c9ddcc"]])

export default __exports__